import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ButtonLoading from '../../Components/UiLoadingComponents/ButtonLoading';
import { selectUser } from '../../features/auth/selector';
import { useGetQuizzesWithVideoIdQuery } from '../../features/quiz/quizApi';
import { useGetQuizMarkWithStudentIdAndVideoIdQuery } from '../../features/quizMark/quizMarkApi';

const QuizTab = ({ videoId }) => {
    const { user } = useSelector(selectUser)
    const { data: quizzes, isLoading: isQuizzesLoading, } = useGetQuizzesWithVideoIdQuery(videoId);
    const { data: quizMark, isLoading: isQuizMarkLoading, } = useGetQuizMarkWithStudentIdAndVideoIdQuery({ videoId, studentId: user.id });

    const isQuizzesExist = Boolean(quizzes?.length)
    const isQuizSubmitted = Boolean(quizMark?.length)

    let content = null;
    if (isQuizzesLoading || isQuizMarkLoading) {
        content = <div>
            <ButtonLoading></ButtonLoading>
        </div>
    }
    else if (isQuizSubmitted) {
        const markForSingleQuiz = 5
        const totalSubmittedQuiz = quizMark[0].totalMark / markForSingleQuiz;
        const totalQuizzes = quizzes.length;
        if (totalQuizzes > totalSubmittedQuiz) {

            content = <div className='flex gap-4'>
                <Link to={`/quizzes/${videoId}`}>
                    <button
                        className="quizButton notSubmitted">New Quiz Found! Participate</button>
                </Link>
            </div>

        } else {
            content =
                <Link to={`/quizzes/${videoId}`}>

                    <button className="quizButton submitted">
                        Quiz result {quizMark[0].mark}/{quizMark[0].totalMark}
                    </button>
                </Link>
        }
    }
    else if (isQuizzesExist) {
        content = <Link to={`/quizzes/${videoId}`}>
            <button
                className="quizButton notSubmitted">কুইজে
                অংশগ্রহণ
                করুন</button>
        </Link>

    }

    return (
        <>
            {content}
        </>
    );
};

export default QuizTab;